// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bcn_a bih_a bih_q bih_j bih_wl bih_bj","ImgResponsive__img":"bcn_b bih_b bih_ql"};